import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTheme } from './ThemeContext';
import './DropdownMenu.css';

const DropdownMenu = ({ user, isSoloMode }) => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { theme, isAscii, toggleTheme, toggleAscii } = useTheme();
  const isDark = theme === 'dark';

  // Keep all state information for multiplayer mode
  const { roomId, roomName, username, userId, isMultiplayer, usernames, picture } = location.state || {};

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleNavigation = (path) => {
    if (isSoloMode) {
      navigate('/');
    } else {
      // Keep the existing navigation state for multiplayer mode
      const navigationState = {
        roomId,
        roomName,
        username,
        userId,
        isMultiplayer,
        usernames,
        picture,
        user: {
          id: userId,
          username,
          picture
        }
      };

      navigate(path, { state: navigationState });
    }
    setIsOpen(false);
  };

  return (
    <div className="dropdown-menu">
      <button
        className="theme-toggle-button"
        onClick={toggleTheme}
        title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      >
        {isDark ? '☀' : '☾'}
      </button>
      <button
        className="ascii-toggle-button"
        onClick={toggleAscii}
        title={isAscii ? 'ASCII mode ON' : 'ASCII mode OFF'}
        style={{ fontFamily: '"Courier New", Courier, monospace', fontWeight: 'bold', fontSize: '0.75rem' }}
      >
        {'> _'}
      </button>
      <button className="menu-button" onClick={toggleMenu}>
        ☰
      </button>
      {isOpen && (
        <div className="menu-content">
          {isSoloMode ? (
            <button onClick={() => handleNavigation('/')}>To Main Page</button>
          ) : (
            <>
              <button onClick={() => handleNavigation('/game')}>Game</button>
              <button onClick={() => handleNavigation('/rankings')}>Rankings</button>
              <button onClick={() => handleNavigation('/')}>Exit Room</button>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default DropdownMenu;
